module.exports = __webpack_public_path__ + "static/img/user-1.aeb0488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile/user-1.jpg
// module id = 5JRZ
// module chunks = 1